import React, { useState, useEffect, useRef } from "react";
import "./Art.scss";
import { formatName, toTitleCase, useToFindItem } from "../../../services/data_requests";
import { Link, useLocation } from "react-router-dom";
import { Modal } from "../../../components";
import { MARKET_ABI } from "../../../contracts/contracts";
import { MARKET_ADDRESS } from "../../../components/Features/Market/Market";

const SOLD_IDS = [143, 176, 164, 51];

const PhyArt = ({ data }) => {
  const location = useLocation();

  const [artItem, setArtItem] = useState(location.state || data || {});
  const isSold = SOLD_IDS.includes(Number(artItem.id));
  const [activeTab, setActiveTab] = useState("about");
  const [shareText, setShareText] = useState("Share");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showFullImage, setShowFullImage] = useState(false);

  const ownerData = useToFindItem("artist", data?.artist?.id);

  useEffect(() => {
    if (location.state) {
      setArtItem(location.state);
    } else if (data) {
      setArtItem(data);
    }
  }, [location.state, data]);

  const handleShare = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      setShareText("Copied");
      setTimeout(() => setShareText("Share"), 3000);
    });
  };

  return (
    <div className="art-single-page">
      <div className="ars-container">
        <div className="ars-preview-container">
          <div className="ars-preview2" onClick={() => setIsModalOpen(true)}>
            <img
              className="ars-preview-img"
              src={artItem.prev_img_url}
              alt={artItem.name}
              onClick={() => setShowFullImage(true)}
            />
          </div>
        </div>

        <div className="ars-info">
          <div className="ars-title">
            <h1>{toTitleCase(artItem.name)}</h1>
            <div className="share-btn" onClick={handleShare}>
              {shareText}
            </div>
          </div>

          <div className="ars-title-under">
            <span>
              {artItem.type === "NFT" ? "Gallery/artwork" : `Gallery/artwork`}
            </span>
          </div>

          {isSold ? (
            <div className="price sold-price">Sold</div>
          ) : (
            <div className="price">{artItem.price} USD</div>
          )}

          {isSold ? (
            <div className="purchase-btn sold-btn">Sold</div>
          ) : artItem.stripe_link ? (
            <a href={artItem.stripe_link} className="purchase-btn">
              Purchase - {artItem.price} $
            </a>
          ) : (
            <div className="purchase-btn disabled">Not Available</div>
          )}
        </div>
      </div>
      <div className="tabs">
        <button
          className={activeTab === "about" ? "active" : ""}
          onClick={() => setActiveTab("about")}
        >
          About the work
        </button>

        <button
          className={activeTab === "artist" ? "active" : ""}
          onClick={() => setActiveTab("artist")}
        >
          Artist
        </button>
      </div>

      {activeTab === "about" && (
        <div className="about-section">
          <div>
            <div className="info-grid">
              <p className="info-grid-p">Name</p>
              <span>{artItem.name}</span>
            </div>
            <div className="info-grid">
              <p className="info-grid-p">Collection</p>
              <span>{artItem.collection}</span>
            </div>
            <div className="info-grid">
              <p className="info-grid-p">Size</p>
              <span>{artItem.size}</span>
            </div>
            <div className="info-grid">
              <p className="info-grid-p">Medium</p>
              <span>{artItem.medium}</span>
            </div>
            <div className="info-grid">
              <p className="info-grid-p">Categories</p>
              <span>
                {artItem.categories?.map((c, i) => (
                  <span key={i}>#{c} </span>
                ))}
              </span>
            </div>
            <div className="info-grid">
              <p className="info-grid-p">Description</p>
              <span>{artItem.description}</span>
            </div>
          </div>
        </div>
      )}

      {activeTab === "artist" && (
        <div className="linker">
          {ownerData ? (
            <>
              <Link
                to={`/artist/${formatName(ownerData.name)}-${ownerData.id}`}
              >
                <div className="artist-header">
                  <div
                    className="artst-ava"
                    style={{
                      backgroundImage: `url(${ownerData.img_url})`,
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                    }}
                  ></div>
                  <div>{toTitleCase(ownerData.name)}</div>
                </div>
              </Link>

              <p className="ars-full-bio">{ownerData.bio}</p>
            </>
          ) : (
            <p>Loading...</p>
          )}
        </div>
      )}

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        artItem={artItem}
        source_item={artItem.img_url || null}
        MARKET_ADDRESS={MARKET_ADDRESS}
        MARKET_ABI={MARKET_ABI}
        useFormattedPrice={false}
      />
    </div>
  );
};

export default PhyArt;
